export default __webpack_public_path__ + "static/media/AddNote.39afd410.svg";